import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { apiMiddleware } from 'redux-api-middleware';
import { routerMiddleware } from 'react-router-redux';
import persistState from 'redux-localstorage';
import { fromJS, Map } from 'immutable';
import reducer from './reducer';
import handleNeedsAuthentication from './middleware/handleNeedsAuthentication';

const merge = (initial, persisted) => {
  if (Map.isMap(persisted)) {
    return Map.isMap(initial) ? initial.mergeDeep(persisted) : persisted;
  }

  return initial;
};

const buildStore = (window, history) => {
  const enhancer = compose(
    applyMiddleware(apiMiddleware, thunk, routerMiddleware(history), handleNeedsAuthentication),
    persistState(null, {
      serialize: x => JSON.stringify(x.toJS()),
      deserialize: x => fromJS(JSON.parse(x)),
      merge,
    }),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  );

  return createStore(reducer, enhancer);
};

export default buildStore;



// WEBPACK FOOTER //
// ./src/buildStore.js